export default __webpack_public_path__ + "static/media/room1-MASK-wood-rot27.2909c737.png";